import { Outlet } from "react-router-dom";

const PolicyPage = () => {
  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
};

export default PolicyPage;
